import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import ModalForbiddenMedicine from './ModalForbiddenMedicine';
import ListForbiddenMedicines from './ListForbiddenMedicines';
import ListForbiddenMedicineActions from './ListForbiddenMedicineActions';
import Spinner from 'react-bootstrap/Spinner';
import Modal from '@material-ui/core/Modal';
import DataReactTable from './DataReactTable';
import ReactTableActionsMedics from './ReacTableActionsMedics';

import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';


const ForbiddenMedicineIndex = ({ location }) => {
    const history = useHistory();
    let feasibility = location.state;

    const [dataMedicaments, setDataMedicaments] = React.useState([]);
    const [ForbiddenMedicines, setForbiddenMedicines] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [openModalForbiddenMedicine, setOpenModalForbiddenMedicine] = useState(false);
    const [openMedicaments, setOpenMedicaments] = React.useState(false);

    const [loadMedicaments, setLoadMedicaments] = React.useState(false);

    useEffect(() => {
        listForbiddenMedicines();
    }, []);

    const regresar = () => {
        let _url = "/clinical-studio/dashboard";
        history.push({
            pathname: process.env.PUBLIC_URL +_url,
            state: feasibility
        });
    }

    const doOpenModalForbiddenMedicine = () => {
        setOpenModalForbiddenMedicine(true);
    }

    const doCloseModalForbiddenMedicine = () => {
        setOpenModalForbiddenMedicine(false)
    }

    const listForbiddenMedicines = () => {

        fetch(`${process.env.REACT_APP_PUBLIC_URL}mediproh/consultar?id_estudio=` + location.state.id_estudio, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            let ForbiddenMedicinesData = [];
            for (let i = 0; i < data.length; i++) {
                data[i].feasibility = location.state;
                ForbiddenMedicinesData.push(data[i]);
            }

            setForbiddenMedicines(ForbiddenMedicinesData);

        }).catch(err => {
            setForbiddenMedicines([]);
        });
    }

    const searchMedicaments = async (val) => {
        setLoadMedicaments(true);
        
        let dataSend = 
        {
            principio_activo:val
        }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'medicamento/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.existe) {
                    setDataMedicaments(data.contenido);
                } else {
                    setDataMedicaments([]);
                }
                setLoadMedicaments(false);
            })
            .catch((error) => {
                setLoadMedicaments(false);
                console.error('Error:', error);
                setDataMedicaments([]);
            });
    }

    const ForbiddenMedicinesList = () => {
        return (
            <ListForbiddenMedicines reactTableData={ForbiddenMedicines} ReactTableActions={ListForbiddenMedicineActions} />
        );
    }

    const reactTableMedicaments = {
        tableHeaderData: [{
            Header: 'Principio activo',
            accessor: 'principioactivo',
            disableGlobalFilter: true,
            width: 65,
        },
        {
            Header: 'Producto',
            accessor: 'producto',
        },
        {
            Header: 'Forma Farmacéutica',
            accessor: 'formafarmaceutica',
        },
        {
            Header: 'Codigo',
            accessor: 'atc',
        },
        ],
        tableRowsData: dataMedicaments
    };

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Medicamentos Prohibidos</h3>
                    <h3 className="page-title center-title subhead">{feasibility.nombre_tercero} ({feasibility.acronimo})</h3>
                    
                    <Col md={2}>
                        <div className='top_info_buttons_hc'>
                            <div>
                                <Tooltip
                                    title="Regresar al Dashboard"
                                >
                                    <IconButton
                                        aria-label="upload picture"
                                        component="span"
                                        className='tooltip-top'
                                        onClick={() => {
                                            regresar();
                                        }}
                                    >
                                        <ArrowBackIcon style={{ color: '#153365' }} />
                                    </IconButton>
                                </Tooltip>
                                <span style={{ marginLeft: '0.25em' }}>Regresar al Dashboard</span>
                            </div>
                        </div>
                    </Col>
                </Col>
            </Row>
            <Card>
                <CardBody>
                    <div className="text-center">
                        <Button onClick={doOpenModalForbiddenMedicine} className="btn btn-primary btn-sm text-white">
                            Agregar Medicamento
                        </Button>
                        <Button onClick={() => setOpenMedicaments(true)} className="btn btn-primary btn-sm text-white">
                            Buscar Medicamento Existente
                        </Button>

                    </div>
                    <Row>

                        {isLoading &&
                            <div className="text-center">
                                <Spinner animation="border" variant="success" />
                            </div>
                        }

                        <Container>
                            <ForbiddenMedicinesList />
                        </Container>

                    </Row>
                </CardBody>
            </Card>

            <ModalForbiddenMedicine
                feasibility={location.state}
                listForbiddenMedicines={listForbiddenMedicines}
                doCloseModalForbiddenMedicine={doCloseModalForbiddenMedicine}
                opened={openModalForbiddenMedicine}

            />

            <Modal
                open={openMedicaments}
                onClose={() => {
                    setOpenMedicaments(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <h5 className="bold-text">Medicamentos</h5>
                    </div>
                    <div className="form">
                        <div style={{ display: 'flex', width: '100%' }}>
                            <div className="form__form-group" style={{ marginRight: 10 }}>
                                <span className="form__form-group-label">Principio Activo</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="search-cups"
                                        component="input"
                                        type="text"
                                        placeholder="nombre"
                                        //value={this.props.MedicalOrders.cups.cupsnom}
                                        onChange={(e) => {
                                            searchMedicaments(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        {!loadMedicaments ?
                            <DataReactTable
                                title=""
                                reactTableData={reactTableMedicaments}
                                config={{
                                    withPagination: true,
                                    withSearchEngine: false,
                                    isSortable: false,
                                    watchCustomMenu: false
                                }}
                                ReactTableActions={ReactTableActionsMedics}
                                id_estudio={location.state.id_estudio}
                                id_tercero={location.state.id_tercero}
                                listForbiddenMedicines={listForbiddenMedicines}
                            /> : <div style={{ margin: 'auto', width: 280, height: 480 }}>
                                <div class="load__icon-wrap">
                                    <svg class="load__icon">
                                        <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                    </svg>
                                </div>
                            </div>}
                        {!openMedicaments && dataMedicaments.length == 0 ?
                            <div style={{ margin: 'auto', width: 280, height: 480 }}>
                                No hay elementos que mostrar
                            </div>
                            : null}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                setOpenMedicaments(false);
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_criterial_excinc', // a unique identifier for this form
})(ForbiddenMedicineIndex);